export const PARAGRAPH_AUTHOR_FONT_SIZE_COEFF = 0.875
export const PARAGRAPH_AUTHOR_LINE_HEIGHT_COEFF = 1.5

export const UNIDENTIFIED_SPEAKER_ID = 'unidentified_speaker'
